import React from 'react';

const Pagination = ({ postsPerPage, totalPosts, paginate }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
      <div className="btn-group btn-group-justified">
      <div className='pagination' style={{textDecoration:"none"}}>
        {pageNumbers.map(number => (
           
           <div class="btn-group">
          <span key={number} className='page-item' style={{textDecoration:"none"}}>
           
            <button onClick={() => paginate(number)}  className='page-link btn btn-primary'>
              {number}
            </button>
           
          </span>
          </div>
           
        ))}
      </div>
      </div>
  );
};

export default Pagination;